import React, {Fragment, useContext} from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import DescriptionCard from '../../../shared/library/cards/description';
import ItemList from '../../../shared/library/cards/item-list/';
import {Query} from 'react-apollo';
import {privateUsersUsingViaPersonalStacks} from '../../../data/tool-profile/queries';
import {ComponentContainer, StyledSmallTitle, Spinner, MembersTitle} from './shared/styles';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';
import {updateQuery} from '../utils';
import NavAnchor, {NAV_ANCHOR_OFFSET} from '../../tool-profile/components/shared/nav-anchor';
import {flattenEdges} from '../../../shared/utils/graphql';
import {MobileContext} from '../../../shared/enhancers/mobile-enhancer';
import PrivatePublicIndicator from '../../../shared/library/private-public-indicator';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const Container = glamorous.div({
  margin: '25px 0'
});

const PrivateDeveloperStacks = ({tool}) => {
  const isMobile = useContext(MobileContext);
  return (
    <ComponentContainer>
      <NavAnchor offset={NAV_ANCHOR_OFFSET} />
      <Query
        query={privateUsersUsingViaPersonalStacks}
        variables={{id: tool.id, first: isMobile ? 8 : 9}}
        notifyOnNetworkStatusChange={true}
      >
        {({loading, data, fetchMore}) => {
          const hasData = data && data.tool;
          if (loading && !hasData)
            return (
              <Spinner>
                <Circular size={LARGE} />
              </Spinner>
            );

          if (hasData) {
            const userStacksUsing = flattenEdges(hasData.privateUsersUsingViaPersonalStacks);
            const userStacksUsingCount = hasData.privateUsersUsingViaPersonalStacks.count;
            const developerData =
              userStacksUsing &&
              userStacksUsing.map(developer => {
                return {
                  name: developer.displayName,
                  imageUrl: developer.imageUrl,
                  thumbUrl: developer.thumbRetinaUrl,
                  slug: developer.path,
                  id: developer.id
                };
              });

            const endCursor = hasData.privateUsersUsingViaPersonalStacks.pageInfo.endCursor;
            const hasNextPage = hasData.privateUsersUsingViaPersonalStacks.pageInfo.hasNextPage;

            const onDeveloperLoadMoreClick = () => {
              fetchMore({
                variables: {
                  after: endCursor,
                  first: isMobile ? 16 : 18
                },
                updateQuery
              });
            };

            return (
              <>
                {userStacksUsingCount !== 0 && (
                  <>
                    <DescriptionCard>
                      <MembersTitle>
                        <StyledSmallTitle>{`Developers with ${
                          tool.name
                        } in their stack`}</StyledSmallTitle>
                        <PrivatePublicIndicator typeIndicator="BlueRoundLarge" />
                      </MembersTitle>
                      <Fragment />
                    </DescriptionCard>
                    <Container>
                      <ItemList
                        notFoundItem="developer stacks"
                        item={developerData}
                        hasNextPage={hasNextPage}
                        loading={loading}
                        loadMore={onDeveloperLoadMoreClick}
                      />
                    </Container>
                  </>
                )}
              </>
            );
          }
        }}
      </Query>
    </ComponentContainer>
  );
};

PrivateDeveloperStacks.propTypes = {
  tool: PropTypes.object
};

export default withErrorBoundary(true)(PrivateDeveloperStacks);
